import styled from "styled-components";

export const AdvantagesBlock = styled.div`
  margin-top: 120px;
  padding: 0 var(--container-pad);

  @media (max-width: 600px) {
    margin-top: 70px;
  }
`;

export const HeadText = styled.p`
  line-height: 1.2;
  font-size: clamp(28px, 4vw, 44px);
  text-align: center;
  color: var(--color-primary);
  font-weight: 800;
  margin: 0 0 40px;
  letter-spacing: -0.5px;
`;

export const AdvantagesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 28px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

export const AdvantagesBlocks = styled.div`
  text-align: center;
  background: var(--color-bg-soft);
  border-radius: var(--radius-xl);
  padding: 28px 22px 30px;
  transition: var(--transition);
  border: 1px solid var(--color-border);

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-md);
    border-color: var(--color-primary-light);
  }
`;

export const ImageBlock = styled.div`
  width: 200px;
  height: 200px;
  margin: 0 auto 18px;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;

  @media (max-width: 600px) {
    width: 180px;
    height: 180px;
  }
`;

export const AdvantagesText = styled.div`
  color: var(--color-primary);
  line-height: 1.4;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.2px;
`;

export const BottomTextBlock = styled.div`
  display: flex;
  justify-content: right;
  margin-top: 80px;
`;

export const TextBlock = styled.div`
  border: 6px solid var(--color-primary);
  padding: 25px 45px;
  width: 807px;
  margin-right: 50px;
  border-radius: var(--radius-lg);
`;

export const CursorText = styled.p`
  font-size: 26px;
  line-height: 1.4;
  font-weight: 400;
`;

export const BottomText = styled.p`
  font-size: 22px;
  line-height: 1.4;
  font-weight: 400;
`;
